export const DrillHoleSetType = 'drillHoleSet';